import {
  CardStyleInterpolators,
  StackScreenProps,
} from "@react-navigation/stack";
import {
  ManagePaymentMethodsRootParamList,
  SettingsRootParamList,
} from "../../../../types";
import {
  ModalCloseButton,
  createStackHeaderNavigator,
} from "@towersystems/roam-common-native";
import { ListPaymentMethodsScreen } from "../ListPaymentMethodsScreen";
import { CreatePaymentMethodRootScreen } from "../CreatePaymentMethodRootScreen";
import {
  CreateEditPaymentMethodContext,
  OnAfterAddPaymentMethodFn,
} from "../CreatePaymentMethodRootScreen/context";
import React from "react";
import { useSetupAllStartupEntities } from "../../../../utilities/setup";

export type ManagePaymentMethodsRootScreenProps = StackScreenProps<
  SettingsRootParamList,
  "ManagePaymentMethodsRootScreen"
>;

export const ManagePaymentMethodsRootScreen = ({
  navigation,
}: ManagePaymentMethodsRootScreenProps) => {
  const { fetchAndSyncEntity } = useSetupAllStartupEntities();

  const Stack = createStackHeaderNavigator<ManagePaymentMethodsRootParamList>();

  const handleOnAfterAddPaymentMethodTerminal: OnAfterAddPaymentMethodFn =
    React.useCallback(async (_, navigation) => {
      await fetchAndSyncEntity("payment_methods");
      await fetchAndSyncEntity("pay_types");
      navigation.pop();
    }, []);

  return (
    <CreateEditPaymentMethodContext.Provider
      value={{
        onAfterSavePaymentMethod: handleOnAfterAddPaymentMethodTerminal,
      }}
    >
      <Stack.Navigator
        screenOptions={{
          animationEnabled: true,
        }}
      >
        <Stack.Group
          screenOptions={{
            headerShown: true,
            headerLeft: () => <ModalCloseButton type="Back" />,
            cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
            title: "",
          }}
        >
          <Stack.Screen
            name="ListPaymentMethodsScreen"
            component={ListPaymentMethodsScreen}
          />
        </Stack.Group>
        <Stack.Group
          screenOptions={{
            animationEnabled: true,
            cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
            headerShown: false,
          }}
        >
          <Stack.Screen
            name="CreatePaymentMethodRootScreen"
            component={CreatePaymentMethodRootScreen}
          />
        </Stack.Group>
      </Stack.Navigator>
    </CreateEditPaymentMethodContext.Provider>
  );
};
